import BaseRepository from "core/repository/base.repository";
import { CustomerService } from "core/service";
import { CustomerPersistence } from "core/persistence";
import { Customer } from "core/entity";
import Papa from "papaparse";

class CustomerRepository extends BaseRepository {
  syncable = false;

  resourceName = () => "clientes";

  getEntityIdentifier = () => "customer";

  getPersistenceProvider = () => CustomerPersistence;

  getServiceProvider = () => CustomerService;

  getCnpjInfo = cnpj => this.mService.getCnpjInfo(cnpj);

  getZipcodeInfo = zipcode => this.mService.getZipcodeInfo(zipcode);

  async modelToEntity(model) {
    return new Customer(model);
  }

  async fetch(companyUuid, { filters = [], order = [], pagination = {} }) {
    const serviceResult = await this.mService.fetch(companyUuid, {
      filters,
      order,
      pagination
    });

    if (serviceResult.success) {
      return {
        success: true,
        results: serviceResult.data,
        total: serviceResult.headers["total"],
        perPage: serviceResult.headers["per-page"]
      };
    }

    return {
      success: false,
      fatal: serviceResult.fatal,
      errors: serviceResult.errors
    };
  }

  async fetchByUuid(companyUuid, uuid) {
    return this.mService.fetchByUuid(companyUuid, uuid);
  }

  async delete(uuid) {
    return await this.update(uuid, { deleted: true });
  }

  async getCustomerCsvContent({ order, filters }, configField) {
    const fields = [
      "Nome",
      "Email",
      "Identificação",
      "Telefone",
      "Data de Nascimento",
      "Endereço",
      "Observação",
      "Informações Personalizadas"
    ];
    const data = [];

    // TODO: Remove company_uuid from stream
    const currentUser = await this.mRuntime.get("currentUser");
    const companyUuid = currentUser.company_uuid;

    const success = await this.mService.stream(
      companyUuid,
      { order, filters },
      async model => {
        const customer = await this.modelToEntity(model);

        if (customer) {
          data.push([
            customer.name,
            customer.email,
            customer.identification,
            customer.phone,
            customer.birth_date,
            customer.getAddress(),
            customer.notes,
            customer.getCustomFields(configField)
          ]);
        } else {
          data.push([customer.name, "-", "-", "-", "-", "-", "-", "-"]);
        }
      }
    );

    if (!success) {
      return { success: false };
    }

    return {
      success: true,
      data: Papa.unparse({ fields, data })
    };
  }
}

export default new CustomerRepository();



// WEBPACK FOOTER //
// ./src/core/repository/customer.repository.js